<div class="input-date__label">
  <p class="label-form">{{label}} <span class="caption">{{caption}}</span></p>
</div>
<input  placeholder="dd.mm.yyyy" type="date" min="{{min}}" max="{{max}}" [(ngModel)]="value" (ngModelChange)="valueChanged()" />

@if (showOverlay) {
  <div (click)="DatePicker()" class="ios-date-overlay"></div>
}

